import SvgLib from '@/components/SvgLib'
import OutlineButton from '@/components/OutlineButton'
import { bus } from '@/consts'
import { TimelineMax } from 'gsap'

export default {
  name: 'Triumph',
  template: '#triumph-template',
  data () {
    return {
      introComplete: false
    }
  },
  components: { SvgLib, OutlineButton },
  mounted () {
    this.$nextTick(() => {
      let triumphTl = new TimelineMax()
      triumphTl.fromTo(this.$refs.triumphBg, 1.5, {scale: 1.08}, {scale: 1})
      triumphTl.addCallback(() => { this.introComplete = true }, 0.5)
      bus.$emit('closeOverlay')
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/triumph/Triumph.js